import NavBar from '../components/linkTrees/home/linktree/navbar/main';
import Body from '../components/linkTrees/home/linktree/body/main';

export default function LinkTree(){
    return(
        <div>
            <NavBar/>
            <Body/>
        </div>
    )
}